import(/* webpackMode: "eager", webpackExports: ["default"] */ "/srv/feelgood-dev2/src/app/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/srv/feelgood-dev2/src/app/components/Header.tsx");
